import React, { useEffect } from 'react';
import { Buffer } from 'buffer';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { LoadingComponent } from 'components/Loading';
import { useQuery } from 'pages/IframeLogin';
import { useToast } from 'hooks/toast';
import { loginReclamante } from 'api/services/Reclamante';
import useLocalStorage, { getItemInStorage } from 'hooks/useLocalStorage';
import { IReclamante } from 'dtos/Reclamante';
import { prefix } from '../../router';

interface IIdTokenGovDecoded {
  aud: string;
  email: string;
  email_verified: string;
  jti: string;
  picture: string;
  social_name: string;
  sub: string;
  name: string;
}

export default function LoadingGovLogin() {
  const [, setAccessToken] = useLocalStorage<string | undefined>('accessToken', '');
  const [, setRefreshToken] = useLocalStorage<string | undefined>('refreshToken', '');
  const [, setDadosReclamante] = useLocalStorage<IReclamante | string>('reclamante', '');
  const [codMunicipio, _] = useLocalStorage<number>('cod_municipio', -1);
  const [, setIsLoginGov] = useLocalStorage<boolean>('is_login_gov', false);

  const query = useQuery();
  const history = useHistory();
  const toast = useToast();

  const handleLoginReclamanteGov = async (code: string, codParqueServico: string) => {
    const redirectUrl = decodeURIComponent(
      decodeURIComponent(`${process.env.REACT_APP_URL_REDIRECT_GOV}%2Fiframe-${codParqueServico}/`),
    );

    const data = new URLSearchParams({
      code,
      grant_type: 'authorization_code',
      redirect_uri: redirectUrl,
    });

    const authorization = Buffer.from(
      `${process.env.REACT_APP_CLIENT_ID_GOV}:${process.env.REACT_APP_CLIENT_SECRET_GOV}`,
      'utf-8',
    ).toString('base64');

    try {
      const responseGov = await axios.post('https://sso.acesso.gov.br/token', data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Basic ${authorization}`,
        },
      });

      const resultDecoded: IIdTokenGovDecoded = (window as any).jwtDecode(responseGov.data.id_token);

      const res = await loginReclamante({
        email: resultDecoded.email,
        tokenGov: responseGov.data.id_token,
        cod_municipio: Number(codMunicipio),
        cod_parque_servico: Number(codParqueServico),
      });

      if (res.failed) {
        throw new Error(res.message);
      }

      if (!res.data || !res.data.complainant) {
        throw new Error('Usuário ou senha inválidos!');
      }

      const { 'x-access-token': accessToken, 'x-refresh-token': refreshToken } = res.headers;

      setAccessToken(accessToken);
      setRefreshToken(refreshToken);
      setDadosReclamante(res.data.complainant);
      setIsLoginGov(true);

      toast.addToast({
        type: 'success',
        description: 'Usuário logado com sucesso!',
      });

      const redirectCodPontoServico = Number(getItemInStorage('redirect_cod_ponto_servico'));
      const redirectEtiquetaPonto = getItemInStorage('redirect_etiqueta_ponto');

      history.push(
        redirectCodPontoServico && redirectCodPontoServico !== -1 && redirectEtiquetaPonto
          ? `${prefix}/generate/ponto`
          : `${prefix}/home`,
      );
    } catch (error: any) {
      toast.addToast({ type: 'error', description: error?.message || 'Usuário ou senha inválidos!' });

      setTimeout(() => {
        history.push('/');
      }, 4000);
    }
  };

  useEffect(() => {
    const codParqueServico = query.get('cod_parque_servico');
    const code = query.get('code');

    if (!codParqueServico || !code) {
      history.push('/');
      return;
    }

    handleLoginReclamanteGov(code, codParqueServico);
  }, [history]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <LoadingComponent size={30} style={{ width: '30px' }} button color="#7764e4" />
    </div>
  );
}
